import type {
  WebReportSectionTemplate,
  WebReportSectionType,
} from '~/stores/webReport'

/** Sidebar and section header order per Figma (Securitas report). */
const webReportSectionOrder: WebReportSectionType[] = [
  'cover',
  'about',
  'client_overview',
  'assessment_method',
  'matrix',
  'assessment_overview',
  'summary',
  'conclusion',
]

export function sortWebReportSections(
  sections: WebReportSectionTemplate[],
): WebReportSectionTemplate[] {
  const orderMap = new Map(
    webReportSectionOrder.map((type, index) => [type, index]),
  )
  const typeRank = (section: WebReportSectionTemplate) =>
    orderMap.get(section.type) ?? 99

  // Stored order wins; type order is the fallback for newly injected sections.
  return [...sections]
    .sort((a, b) => {
      const aKey = typeof a.order === 'number' ? a.order : typeRank(a)
      const bKey = typeof b.order === 'number' ? b.order : typeRank(b)
      return aKey - bKey || typeRank(a) - typeRank(b)
    })
    .map((section, order) => ({ ...section, order }))
}
